import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '界面规则',
    type: 'UI_RULE',
}
